import {
  dataDogLogger,
  DataDogLoggerActionTypes,
} from 'commons/utils/dataDogLogger';

export function logRejectionByFileType(file: File) {
  dataDogLogger.generate({
    actionMessage: `File upload rejected for file ${file.name}`,
    actionOwner: 'DocumentUploader.tsx',
    actionData: {
      fileName: file.name,
      fileType: file.type,
    },
    actionType: DataDogLoggerActionTypes.Warn,
  });
}

export function logRejectionByFileSize(file: File) {
  dataDogLogger.generate({
    actionMessage: `File size exceeded for ${file.name}`,
    actionOwner: 'DocumentUploader.tsx',
    actionData: {
      fileName: file.name,
      fileType: file.type,
      fileSize: file.size,
    },
    actionType: DataDogLoggerActionTypes.Warn,
  });
}

export function logFailure(file: File, documentName: string, error: unknown) {
  dataDogLogger.generate({
    actionMessage: `File upload error`,
    actionOwner: 'DocumentUploader.tsx',
    actionData: {
      fileSize: file.size,
      fileRawName: file.name,
      fileName: documentName,
    },
    actionType: DataDogLoggerActionTypes.Error,
    error,
  });
}

export function logFileSize(
  file: File,
  documentName: string,
  actionOwner?: string,
) {
  dataDogLogger.generate({
    actionMessage: `The merchant triggered the sending of documents and their file size is ${file.size}`,
    actionOwner: actionOwner || 'DocumentUploader.tsx',
    actionData: {
      fileSize: file.size,
      fileRawName: file.name,
      fileName: documentName,
    },
    actionType: DataDogLoggerActionTypes.Info,
  });
}
